import React from "react";
import { CheckCircle2, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function OnboardingChecklistItem({
    title,
    description,
    completed,
    onClick,
    icon: Icon,
    credits,
    highlight,
}) {
    const { t } = useTranslation();

    return (
        <div className={highlight ? "ring-2 ring-primary ring-offset-2 rounded-lg" : ""}>
            {highlight && (
                <div className="bg-primary text-primary-foreground text-xs font-bold px-3 py-1 rounded-t-lg text-center">
                    {t("onboarding.startHere")}
                </div>
            )}
        <button
            onClick={completed ? undefined : onClick}
            disabled={completed}
            className={`w-full flex items-center gap-4 p-4 ${highlight ? "rounded-b-lg" : "rounded-lg"} border transition-all text-left ${
                completed
                    ? "bg-green-50 border-green-200 opacity-75"
                    : "bg-white border-gray-200 hover:border-primary hover:shadow-sm cursor-pointer"
            }`}
        >
            <div
                className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${
                    completed
                        ? "bg-green-100 text-green-600"
                        : "bg-primary/10 text-primary"
                }`}
            >
                {completed ? (
                    <CheckCircle2 className="w-5 h-5" />
                ) : (
                    <Icon className="w-5 h-5" />
                )}
            </div>
            <div className="flex-1 min-w-0">
                <p
                    className={`text-sm font-medium ${
                        completed
                            ? "line-through text-muted-foreground"
                            : "text-foreground"
                    }`}
                >
                    {title}
                </p>
                <p className="text-xs text-muted-foreground mt-0.5">
                    {description}
                </p>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
                {credits > 0 && (
                    <span
                        className={`text-xs font-bold px-2 py-1 rounded-full ${
                            completed
                                ? "bg-green-100 text-green-700"
                                : "bg-amber-100 text-amber-700"
                        }`}
                    >
                        {t("onboarding.rewardBadge", { credits })}
                    </span>
                )}
                {!completed && (
                    <ChevronRight className="w-4 h-4 text-muted-foreground" />
                )}
            </div>
        </button>
        </div>
    );
}
